export enum SITE {LOCAL, NJDEMO, NJUAT, NJPROD, DCDEMO, DCPROD, DCLOCAL}

export enum TOOLS {
    ARREST,
    ARREST_ANALYSIS,
    CARJACKING_NOTIFICATION,
    CODIS_NOTIFICATION,
    DEVICE_LOCATION,
    DUPLICATE_PERSON,
    EYE_ON_SCENE,
    FREQUENT_OFFENDER,
    GVRTF_REFERRAL,
    HUMAN_TRAFFICKING,
    JAIL,
    LPR_COMMON_PLATE,
    LPR_SEARCH,
    NCIC_SEARCH,
    NIBIN,
    NOTIFICATION,
    SDW,
    NJTRACE,
    OPEN_CASE,
    PAROLE,
    PERSON_NEARBY,
    PRISONER_INFO,
    PROFESSIONAL_LICENSE,
    PROFILE_REPORT,
    SCOR_SEARCH,
    SCOR_VARIATION,
    SHOOTING_NOTIFICATION,
    SHOTSPOTTER,
    STOLEN_VEHICLE,
    STATUTE_MAPPING,
    THREAT_ASSESSMENT,
    TOWED_VEHICLE,
    VIOLENT_OFFENDER,
    POI,
    UPDATE_PERSON_MAIN_RECORD,
    NJSTAD,
    MISSING_PERSON, //DC
    TRAFFIC_CRASH, //DC
    FIELD_CONTACT, //DC
    SUPPLEMENTAL_REPORT //DC
}

export enum PERSON_PANEL{
    ARREST,
    NJPOP,
    CODIS,
    INFOCOP,
    ETICKED,
    CADRMS,
    PARKING,
    ETRACE,
    NJTRACE,
    NIBIN,
    JAIL,
    PRISION,
    PAROLE,
    VIOLENT,
    REFERRAL,
    PROFILE_REPORT,
    PROFESSION,
    ASSOCIATION_PEOPLE,
    ALPR,
    
    MISSING_PERSON, //DC
    TRAFFIC_CRASH, //DC
    FIELD_CONTACT, //DC
    SUPPLEMENTAL_REPORT, //DC
}

export enum SSO_TYPE {LOCAL_ONLY, DEPT_QUESTION, DEPT_HARDCODED, DEPT_USERID_PARSE}

export function GetSSOTypeForSite(site : SITE) : SSO_TYPE {
    switch (site) {
        case SITE.DCDEMO:
        case SITE.DCPROD:
        case SITE.DCLOCAL:
            return SSO_TYPE.DEPT_USERID_PARSE;
        case SITE.NJDEMO:
        case SITE.NJUAT:
        case SITE.NJPROD:
            return SSO_TYPE.LOCAL_ONLY;
        case SITE.LOCAL:
            return SSO_TYPE.LOCAL_ONLY;
    }
}
export function GetDefaultSSOForSite(site : SITE) : string {
    switch (site) {
        case SITE.DCDEMO:
        case SITE.DCLOCAL:
            return "DEMO_AZURE";
        case SITE.DCPROD:
            return "MPD";
        case SITE.NJDEMO:
        case SITE.NJUAT:
        case SITE.NJPROD:
        case SITE.LOCAL:
            return "";
    }
}
export function IsToolEnabled(TOOL : TOOLS, ENABLED_TOOLS : TOOLS[]) : boolean {
    return ENABLED_TOOLS.includes(TOOL);
}

export function IsPanelEnabled(PANEL : PERSON_PANEL, ENABLED_PANELS : PERSON_PANEL[]) : boolean {
    return ENABLED_PANELS.includes(PANEL);
}


export function GetToolsForSite(site : SITE) : TOOLS[]{
    let tools : TOOLS[] = [];
    switch (site) {
        case SITE.DCPROD:
        case SITE.DCDEMO:
        case SITE.DCLOCAL:
            tools=[
                TOOLS.ARREST,
                TOOLS.ARREST_ANALYSIS,
                // TOOLS.CARJACKING_NOTIFICATION,
                // TOOLS.CODIS_NOTIFICATION,
                // TOOLS.DEVICE_LOCATION,
                // TOOLS.DUPLICATE_PERSON,
                // TOOLS.EYE_ON_SCENE,
                TOOLS.FREQUENT_OFFENDER,
                // TOOLS.GVRTF_REFERRAL,
                // TOOLS.HUMAN_TRAFFICKING,
                // TOOLS.JAIL,
                TOOLS.LPR_COMMON_PLATE,
                TOOLS.LPR_SEARCH,
                // TOOLS.NCIC_SEARCH,
                // TOOLS.NIBIN,
                // TOOLS.NOTIFICATION,
                // TOOLS.SDW,
                // TOOLS.NJTRACE,
                TOOLS.OPEN_CASE,
                // TOOLS.PAROLE,
                TOOLS.PERSON_NEARBY,
                // TOOLS.PRISONER_INFO,
                // TOOLS.PROFESSIONAL_LICENSE,
                // TOOLS.PROFILE_REPORT,
                TOOLS.SCOR_SEARCH,
                TOOLS.SCOR_VARIATION,
                TOOLS.SHOOTING_NOTIFICATION,
                TOOLS.SHOTSPOTTER,
                TOOLS.STATUTE_MAPPING,
                // TOOLS.THREAT_ASSESSMENT,
                // TOOLS.TOWED_VEHICLE,
                // TOOLS.VIOLENT_OFFENDER,
                TOOLS.POI,
                //TOOLS.UPDATE_PERSON_MAIN_RECORD
                TOOLS.MISSING_PERSON, 
                //TOOLS.TRAFFIC_CRASH, 
                TOOLS.FIELD_CONTACT, 
                TOOLS.SUPPLEMENTAL_REPORT
            ]
            break;
        case SITE.NJUAT:
        case SITE.NJPROD:
            tools = [
                TOOLS.ARREST,
                TOOLS.ARREST_ANALYSIS,
                TOOLS.CARJACKING_NOTIFICATION,
                TOOLS.CODIS_NOTIFICATION,
                TOOLS.DEVICE_LOCATION,
                TOOLS.DUPLICATE_PERSON,
                TOOLS.EYE_ON_SCENE,
                TOOLS.FREQUENT_OFFENDER,
                TOOLS.GVRTF_REFERRAL,
                TOOLS.HUMAN_TRAFFICKING,
                TOOLS.JAIL,
                TOOLS.LPR_COMMON_PLATE,
                TOOLS.LPR_SEARCH,
                TOOLS.NCIC_SEARCH,
                TOOLS.NIBIN,
                TOOLS.NOTIFICATION,
                TOOLS.SDW,
                TOOLS.NJTRACE,
                TOOLS.OPEN_CASE,
                TOOLS.PAROLE,
                TOOLS.PERSON_NEARBY,
                TOOLS.PRISONER_INFO,
                TOOLS.PROFESSIONAL_LICENSE,
                TOOLS.PROFILE_REPORT,
                TOOLS.SCOR_SEARCH,
                TOOLS.SCOR_VARIATION,
                TOOLS.SHOOTING_NOTIFICATION,
                TOOLS.SHOTSPOTTER,
                TOOLS.STATUTE_MAPPING,
                TOOLS.STOLEN_VEHICLE,
                TOOLS.THREAT_ASSESSMENT,
                TOOLS.TOWED_VEHICLE,
                TOOLS.VIOLENT_OFFENDER,
                TOOLS.POI,
                TOOLS.UPDATE_PERSON_MAIN_RECORD,
            ]
            break;
        case SITE.NJDEMO:
        case SITE.LOCAL:
            tools = [
                TOOLS.ARREST,
                TOOLS.ARREST_ANALYSIS,
                TOOLS.CARJACKING_NOTIFICATION,
                TOOLS.CODIS_NOTIFICATION,
                TOOLS.DEVICE_LOCATION,
                TOOLS.DUPLICATE_PERSON,
                TOOLS.EYE_ON_SCENE,
                TOOLS.FREQUENT_OFFENDER,
                TOOLS.GVRTF_REFERRAL,
                TOOLS.HUMAN_TRAFFICKING,
                TOOLS.JAIL,
                TOOLS.LPR_COMMON_PLATE,
                TOOLS.LPR_SEARCH,
                TOOLS.NCIC_SEARCH,
                TOOLS.NIBIN,
                TOOLS.NOTIFICATION,
                TOOLS.SDW,
                TOOLS.NJTRACE,
                TOOLS.OPEN_CASE,
                TOOLS.PAROLE,
                TOOLS.PERSON_NEARBY,
                TOOLS.PRISONER_INFO,
                TOOLS.PROFESSIONAL_LICENSE,
                TOOLS.PROFILE_REPORT,
                TOOLS.SCOR_SEARCH,
                TOOLS.SCOR_VARIATION,
                TOOLS.SHOOTING_NOTIFICATION,
                TOOLS.SHOTSPOTTER,
                TOOLS.STATUTE_MAPPING,
                TOOLS.STOLEN_VEHICLE,
                TOOLS.THREAT_ASSESSMENT,
                TOOLS.TOWED_VEHICLE,
                TOOLS.VIOLENT_OFFENDER,
                TOOLS.POI,
                TOOLS.NJSTAD
            ]
            break;
    }
    return tools;
}

export function GetPanelsForSite(site : SITE) : PERSON_PANEL[]{
    let panels : PERSON_PANEL[] = [];
    switch (site) {
        case SITE.DCPROD:
        case SITE.DCDEMO:
        case SITE.DCLOCAL:
            panels=[
                PERSON_PANEL.ARREST,
                //PERSON_PANEL.NJPOP,
                //PERSON_PANEL.CODIS,
                //PERSON_PANEL.INFOCOP,
                //PERSON_PANEL.ETICKED,
                PERSON_PANEL.CADRMS,
                PERSON_PANEL.PARKING,
                //PERSON_PANEL.ETRACE,
                //PERSON_PANEL.NJTRACE,
                PERSON_PANEL.NIBIN,
                //PERSON_PANEL.JAIL,
                //PERSON_PANEL.PRISION,
                //PERSON_PANEL.PAROLE,
                //PERSON_PANEL.VIOLENT,
                //PERSON_PANEL.REFERRAL,
                //PERSON_PANEL.PROFILE_REPORT,
                //PERSON_PANEL.PROFESSION,
                PERSON_PANEL.ASSOCIATION_PEOPLE,
                PERSON_PANEL.ALPR,
                
                PERSON_PANEL.MISSING_PERSON, //DC
                PERSON_PANEL.TRAFFIC_CRASH, //DC
                PERSON_PANEL.FIELD_CONTACT, //DC
                PERSON_PANEL.SUPPLEMENTAL_REPORT //DC
            ]
            break;
        case SITE.NJDEMO:
        case SITE.NJUAT:
        case SITE.NJPROD:
        case SITE.LOCAL:
            panels = [
                PERSON_PANEL.ARREST,
                PERSON_PANEL.NJPOP,
                PERSON_PANEL.CODIS,
                PERSON_PANEL.INFOCOP,
                PERSON_PANEL.ETICKED,
                PERSON_PANEL.CADRMS,
                PERSON_PANEL.PARKING,
                PERSON_PANEL.ETRACE,
                PERSON_PANEL.NJTRACE,
                PERSON_PANEL.NIBIN,
                PERSON_PANEL.JAIL,
                PERSON_PANEL.PRISION,
                PERSON_PANEL.PAROLE,
                PERSON_PANEL.VIOLENT,
                PERSON_PANEL.REFERRAL,
                PERSON_PANEL.PROFILE_REPORT,
                PERSON_PANEL.PROFESSION,
                PERSON_PANEL.ASSOCIATION_PEOPLE,
                PERSON_PANEL.ALPR
            ]
            break;
    }
    return panels;
}

export function GetDefaultStateForSite(site : SITE) : string {
    switch (site) {
        case SITE.DCDEMO:
        case SITE.DCPROD:
        case SITE.DCLOCAL:
            return "DC";
        case SITE.NJDEMO:
        case SITE.NJUAT:
        case SITE.NJPROD:
        case SITE.LOCAL:
            return "NJ";
    }
}

export function GetStringNameForSite(site : SITE, keyword:string) : string{
    switch (keyword.toUpperCase()){
        case "CITY":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return "Zone";
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "City";
                default:
                    return "";
            }
        case "COUNTY":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return "District";
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "County";
                default:
                    return "";
            }
        case "STATUTES":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return "Offenses";
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "Statutes";
                default:
                    return "";
            }
        case "STATUTE":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return "Offense";
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "Statute";
                default:
                    return "";
            }
        case "SCOR":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return "Ranking";
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "SCOR";
                default:
                    return ""
            }
        case "SCOR_TBL":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return ""; // Left empty as you do not show "Ranking Ranking" in the table header. 
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "SCOR ";
                default:
                    return ""
            }
            
        case "NAV_TOOL_OPENCASE":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return "Offense/Incident"; // Left empty as you do not show "Ranking Ranking" in the table header. 
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "Open Case Incident";
                default:
                    return ""
            }

        case "SBI #":
            switch (site) {
                case SITE.DCDEMO:
                case SITE.DCPROD:
                case SITE.DCLOCAL:
                    return "PDID #"; // Left empty as you do not show "Ranking Ranking" in the table header. 
                case SITE.NJDEMO:
                case SITE.NJUAT:
                case SITE.NJPROD:
                case SITE.LOCAL:
                    return "SBI #";
                default:
                    return ""
            }
        default:
            return "";
    }
}